import { render, staticRenderFns } from "./ServiceUpdate.vue?vue&type=template&id=5aaaf1db&"
import script from "./ServiceUpdate.vue?vue&type=script&lang=js&"
export * from "./ServiceUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports